import type { ProgramEventType } from 'models';
import type { ReactNode } from 'react';
import { Col, Icon, RoundElement, Row, Title } from 'ui';

type P = {
  className?: string;
  content?: ReactNode;
  id?: string;
  onClick: (eventType: ProgramEventType) => void;
  title: ReactNode | string;
  value: ProgramEventType;
};

const Card = ({ className, content, onClick, title, value, ...htmlProperties }: P) => {
  const getImage = () => {
    switch (value) {
      case 'conference':
        return <Icon icon="camcorder-line" />;
      case 'webinar':
        return <Icon icon="presentation-2-line" />;
    }
  };

  return (
    <button
      className={`t_card ${className ?? ''}`}
      id={htmlProperties.id}
      onClick={() => {
        onClick(value);
      }}
      type="button"
    >
      <Row>
        <Col className="t_card__content-left">
          <RoundElement className="t_card__icon" size="small">
            {getImage()}
          </RoundElement>
        </Col>
        <Col className="t_card__content-right">
          <Title className="t_card__title" level={5} marginBottom>
            {title}
          </Title>

          <div className="t_card__body">{content}</div>
        </Col>
      </Row>
    </button>
  );
};

export default Card;
